module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword#foreword"
    }
  }, [_vm._v("Foreword")]), _vm._v(" by John C. Maxwell")]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch00#ch00"
    }
  }, [_vm._v("Introduction: "), _c('em', [_vm._v("Serve First and Lead Second")]), _vm._v(" Ken Blanchard and Renee Broadwell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_vm._v("Fundamentals of Servant Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1. What Is Servant Leadership?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au"
  }, [_vm._v("Ken Blanchard")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("2. Characteristics of Servant Leaders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au"
  }, [_vm._v("Larry C. Spears")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch03#ch03"
    }
  }, [_vm._v("3. Servant Leadership Is Conscious Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au"
  }, [_vm._v("Raj Sisodia")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Servant Leadership at the Speed of Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au"
  }, [_vm._v("Stephen M. R. Covey")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Great Leaders SERVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au"
  }, [_vm._v("Mark Miller")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Servant Leadership: What Does It Really Mean?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au"
  }, [_vm._v("Mark A. Floyd")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Servant Leaders Create a Great Place to Work for All")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au"
  }, [_vm._v("Michael C. Bush")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Leader as Shepherd")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au"
  }, [_vm._v("Holly Culhane")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Evolution of Servant Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au"
  }, [_vm._v("Simon Sinek")]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elements of Servant Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. One Question Every Servant Leader Should Ask")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Marshall Goldsmith")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. In the Service of Others: When Leaders Dare to Rehumanize Work")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Brené Brown")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Servant Leaders Celebrate Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Tom Mullins")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Servant Leader’s Focus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("James Ferrell")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. What You See Determines How You Serve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Chris Hodges")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Compassion: The Heart of Servant Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Craig Groeschel")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. How to Spot Ideal Team Players")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Patrick Lencioni")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. The Servant Leader Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Laurie Beth Jones")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. The Four Corners of the Leader’s Universe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Henry Cloud")]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03#part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03#part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lessons in Servant Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Finding Your Voice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("James M. Kouzes and Barry Z. Posner")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. A Lesson from My Father: Washing Feet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Phyllis Hennecy Hendry")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. The Puddle Is Not the Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Neal Nybo")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Five Army-Tested Lessons of Servant Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Jeffrey W. Foley")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. A Baptism of Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Erwin Raphael McManus")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Little Things and Big Things")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Jon Gordon")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. In Praise of Followership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Margie Blanchard")]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04#part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04#part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exemplars of Servant Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Jesus: The Greatest Example of a Servant Leader")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Ken Blanchard and Phil Hodges")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Andrew Young: Partner in Servant Leadership to Martin Luther King Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("John Hope Bryant")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Pat Summitt: Steely Eyes, Servant Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Tamika Catchings")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Dallas Willard: The Smartest Man I Ever Met")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Tony Baron")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Henry Blackaby: A Lifelong Servant Leader")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Richard Blackaby")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. Frances Hesselbein: To Serve Is to Live")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Jim Dittmar")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Charlie “Tremendous” Jones: A Sermon Seen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Mark Sanborn")]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05#part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05#part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Putting Servant Leadership to Work")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. Treat Your People as Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Colleen Barrett")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. Developing and Using Servant Leadership in the Military")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Robin Blanchard")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Leading Is Serving")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Dave Ramsey")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. Serving from an HR Perspective")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Shirley Bullard")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. It’s How You Treat People")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("James H. Blanchard")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. How Servant Leadership Has Shaped Our Church Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Miles McPherson")]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part06#part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part06#part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Servant Leadership Turnarounds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. Out of the Flames, into the Light")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Art Barter")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. Serve the People")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Cheryl Bachelder")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. Waste Connections: A Servant Leadership Success Story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Rico Maranto")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. Don’t Mark My Paper, Help Me Get an A")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Garry Ridge")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/app01#app01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Comments: "), _c('em', [_vm._v("The Power of Love, Not the Love of Power")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-au1"
  }, [_vm._v("Ken Blanchard and Renee Broadwell")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/editors#editors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Editors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/services#services",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Services Available")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/join#join",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Join Us Online")]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0